<template>
  <div>
    <v-row>
      <v-col :cols="4">
        <v-text-field :value="customer_id" :label="'Kundennummer'" :placeholder="'Kundennummer'" type="text" min="5" max="6" class="flex" />
        <v-text-field @input="autocompleteUrl($event)" :value="url" :label="'URL'" :placeholder="'URL'" type="text" min="6" max="255" class="flex" />
        <v-checkbox color="primary" :label="'Prüfe Optimierungen'" v-model="check_optimization"></v-checkbox>
        <v-checkbox color="primary" :label="'Prüfe Screenshot'" v-model="check_screenshot"></v-checkbox>
        <v-checkbox color="primary" :label="'Prüfe Anzahl Wörter'" v-model="check_countwords"></v-checkbox>
      </v-col>
      <v-col :cols="8">
        <optimization v-for="(optimization, i) in optimizations" :key="i" :index="i" :value="optimization" @dismissed="removeOptimization($event)" />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import Optimization from "./Optimization"

export default {
  components: {
    Optimization
  },
  props: {
    customer_id: {
      type: Number,
      default: null
    },
    url: {
      type: String,
      default: null
    },
    check_optimization: {
      type: Boolean,
      default: true
    },
    check_screenshot: {
      type: Boolean,
      default: false
    },
    check_countwords: {
      type: Boolean,
      default: false
    },
    optimizations: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    autocompleteUrl(event) {
      if (!this.url.startsWith('http://') || !this.url.startsWith('https://')) {
        this.url = 'https://' + this.url
      }
    },
    removeOptimization(event) {
      console.log('remove ' + event)
    }
  }
}

</script>
